import Vue from 'vue'
import Vuex from 'vuex'
import {actions} from './services/actions'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        plans: {},
        userPlanInfo: {},
        selectedPlanIndex: 0,
        createdUser: {},
        baseUrl: process.env.VUE_APP_API_URL,
        currentBrand: {},
        currentOpposition: {},
        tags: [],
        loggedUser: {
            id: '',
            first_name: '',
            last_name: '',
            email: '',
            plan: {},
            roles: [],
            status: '',
            valid_to: '',
            trademark_monitoring: true,
            billing_info: {
                billingType: '',
                planId: 0,
                companyName: '',
                vat: '',
                address: '',
                city: '',
                country: ''
            }
        }
    },
    mutations: {
        setPlans(state, plans) {
            state.plans = plans;
        },
        setPlanInfo(state, planInfo) {
            state.userPlanInfo = planInfo;
        },
        setSelectedPlanIndex(state, planIndex){
            state.selectedPlanIndex = planIndex;
        },
        setCreatedUser(state, user) {
            state.createdUser = user;
        },
        setLoggedUser(state, loggedUser) {
            state.loggedUser = loggedUser;
            state.userPlanInfo = loggedUser.plan;
        },
        setCurrentBrand(state, brand) {
            state.currentBrand = brand;
        },
        setCurrentOpposition(state, opposition) {
            state.currentOpposition = opposition;
        },
        setTags(state, tags) {
            state.tags = tags
        }
    },
    getters: {
        hasData: (state) => (stateName) => {
            for (let key in state[stateName]) {
                if (state[stateName].hasOwnProperty(key)) {
                    return true;
                }
            }
            return false;
        },
        isAuthenticated: () => {
            return (localStorage.getItem('user-token') !== null);
        }
    },
    actions
})
